"use strict";

exports.__esModule = true;
exports.ClassificationSelectorMenu = ClassificationSelectorMenu;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _ClassificationSelectorIcon = require("./ClassificationSelectorIcon");
var _PlantStateActivities = require("../../PlantStateActivities");
var _Utils = require("../../../Utils");
var _excluded = ["plantStateActivities", "activityPredicate", "onClick", "theme", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows a list of applicable classification buttons in a menu.
 */
function ClassificationSelectorMenu(props) {
  var plantStateActivities = props.plantStateActivities,
    _props$activityPredic = props.activityPredicate,
    activityPredicate = _props$activityPredic === void 0 ? function () {
      return true;
    } : _props$activityPredic,
    _onClick = props.onClick,
    theme = props.theme,
    children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var activities = plantStateActivities.activities,
    states = plantStateActivities.states,
    mapping = plantStateActivities.mapping;
  var groups = [];
  var stateGroup = [];
  var _loop = function _loop() {
    var item = mapping[i];
    var state = (0, _PlantStateActivities.getPlantState)(states, item.stateId);
    var body = [];
    var _loop2 = function _loop2() {
      var activityMapping = item.activities[j];
      var forceComment = activityMapping.forceComment,
        rank = activityMapping.rank;
      var activity = (0, _PlantStateActivities.getPlantActivity)(activities, activityMapping.id);
      if (activityPredicate(state, activity)) {
        var key = state.id + ":" + activity.id;
        body.push(/*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          key: key,
          icon: /*#__PURE__*/_react["default"].createElement(_ClassificationSelectorIcon.ClassificationSelectorIcon, {
            theme: theme,
            state: state
          }),
          text: activity ? activity.name : state.name,
          onClick: function onClick() {
            return _onClick({
              state: state,
              activity: activity,
              forceComment: forceComment,
              rank: rank
            });
          }
        }));
      }
    };
    for (var j = 0; j < item.activities.length; j++) {
      _loop2();
    }
    if (body.length > 0) {
      groups.push.apply(groups, body);
    } else if (activityPredicate(state)) {
      stateGroup.push(state);
    }
  };
  for (var i = 0; i < mapping.length; i++) {
    _loop();
  }
  var sortedStateGroup = sortByKey(stateGroup);
  var sortedStateGroupBody = sortedStateGroup.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: item.id,
      icon: /*#__PURE__*/_react["default"].createElement(_ClassificationSelectorIcon.ClassificationSelectorIcon, {
        theme: theme,
        state: item
      }),
      text: item.name,
      onClick: function onClick() {
        return _onClick({
          state: item,
          activity: undefined,
          forceComment: false,
          rank: 0
        });
      }
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Menu, _extends({
    "data-testid": "ClassificationSelectorMenu.menu",
    style: {
      overflow: "auto"
    }
  }, extra), sortedStateGroupBody, sortedStateGroupBody.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), groups, children);
}
var sortByKey = (0, _Utils.memoize)(function (stateArray) {
  return (0, _Utils.sortArrayOfObjectsByKey)(stateArray, "name");
});